module.exports = __webpack_public_path__ + "top_page/icon-search-2e12621fa601e262f1a38143d7699d27.svg";